//-----------------------------
// get column heading by index
//-----------------------------
export default function getColumnHeadingByIndex(headings, hover_col) {
  //--------------------
  // return col heading
  //--------------------
  let non_hidden_headings = headings.filter((a) => a.hidden != true)
  return non_hidden_headings[hover_col].field;
}
